import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import RefundForm from '../emails/refundForm';
import GroupRefundForm from '../emails/groupRefundForm';

const AdminDeliveryDayMarketplaceView = ({ match }) => {
  const [showGroupRefund, setShowGroupRefund] = useState(false);
  const [modalOrder, setModalOrder] = useState(null);
  const [ordersError, setOrdersError] = useState(null);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getOrders();
  }, []);

  function getOrders() {
    apiCalls
      .getOrders({
        deliveryDayMarketplaceId: match.params.deliveryDayMarketplaceId,
      })
      .then((result) => {
        setOrders(result.data.orders);
        setOrdersLoading(false);
      })
      .catch((errors) => {
        setOrdersError(utils.getErrorMessageFromResponse(errors));
        setOrdersLoading(false);
      });
  }

  const orderRows = orders
    ? orders.map((order, index) => {
        return (
          <tr key={index}>
            <th scope="row">
              {order.businessProfile ? (
                <Link to={`/admin/businessProfiles`}>
                  B{order.businessProfile.id} - {order.businessProfile.companyName}
                </Link>
              ) : (
                <Link to={`/admin/users/${order.user.id}`}>
                  #{order.user.id} - {order.user.screenName}
                </Link>
              )}
            </th>
            <td>
              {order.items.map((orderItem, index) => {
                return (
                  <div key={index}>
                    {orderItem.quantity > 1 ? <strong className="text-primary">{orderItem.quantity} x </strong> : ''}{' '}
                    {orderItem.itemName} #{orderItem.item.id} - {orderItem.itemPrice}€
                  </div>
                );
              })}
            </td>
            <td>
              <div>Order id: #{order.id}</div>
              <div>
                Batch id: <Link to={`/admin/orderBatches/${order.batchId}`}>#{order.batchId}</Link>
              </div>
              <div>
                Payment id:{' '}
                <a
                  className="link"
                  href={`https://dashboard.stripe.com/payments/${order.payment.paymentIntentId}`}
                  target="_blank"
                >
                  #{order.payment.id}
                </a>
              </div>
            </td>
            <td>{order.totalSum}€</td>
            <td>
              {order.refunds.map((refund, index) => {
                return (
                  <div key={index}>
                    {refund.amount}€ - "{refund.comment}"
                  </div>
                );
              })}
            </td>
            <td>
              <button className="btn btn-normal-link" onClick={() => setModalOrder(order)}>
                <FormattedMessage id={'admin.delivery.day.marketplace.table.column.actions.refund'} />
              </button>
            </td>
          </tr>
        );
      })
    : '';

  return (
    <div className="community-view__panel">
      <div className="community-view__panel-corner">
        <i className="fa fa-car" />
      </div>

      <Loader show={ordersLoading} />
      <ErrorMessage error={ordersError} />

      <div className="m-b-3">
        <button className="btn btn-default btn-small" onClick={() => setShowGroupRefund(true)}>
          <FormattedMessage id={'admin.delivery.day.marketplace.actions.group.refund'} />
        </button>
      </div>

      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.user'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.items'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.order'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.total'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.refunds'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.delivery.day.marketplace.table.column.actions'} />
            </th>
          </tr>
        </thead>
        <tbody>{orderRows}</tbody>
      </table>

      <Modal show={!!modalOrder} onHide={() => setModalOrder(null)} size="lg">
        <div onClick={() => setModalOrder(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {modalOrder ? (
            <RefundForm
              order={modalOrder}
              closeModal={() => {
                setModalOrder(null);
                getOrders();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>

      <Modal show={showGroupRefund} onHide={() => setShowGroupRefund(false)} size="lg">
        <div onClick={() => setShowGroupRefund(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {showGroupRefund ? (
            <GroupRefundForm
              deliveryDayMarketplaceId={match.params.deliveryDayMarketplaceId}
              closeModal={() => {
                setShowGroupRefund(false);
                getOrders();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </div>
  );
};

AdminDeliveryDayMarketplaceView.propTypes = {
  currentUser: PropTypes.object,
};

AdminDeliveryDayMarketplaceView.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(AdminDeliveryDayMarketplaceView));
